import { Text } from "@mantine/core";

interface CombinedReferenceProps {
  reference?: string | null;
}

const CombinedReference: React.FC<CombinedReferenceProps> = ({ reference }) => {
  if (!reference) return null;

  return (
    <Text fz={"sm"} fw={500}>
      <span className="font-semibold">REF:</span> {reference}
    </Text>
  );
};

export default CombinedReference;
